<template>
  <router-view />
</template>

<script setup lang="ts"></script>

<style>
html, body, #app { height: 100%; margin: 0; }
* { box-sizing: border-box; }
</style>